export const defaultFilterValue = '1 = 1'

export const THROTTLE_DELAY = 300
